import {useCallback} from 'react'

import {COMMAND_TYPES} from '../../constants/command-types'
import {useCLIModeSync} from '../../hooks/use-cli-mode-sync'
import {useCreateCommand} from '../../hooks/useCreateCommand'
import {CLIModePicker, type CLIAgentMode} from './CLIModePicker'

interface CLIModeToolbarSlotProps {
  sessionId: string
  taskId?: string
}

export function CLIModeToolbarSlot({sessionId, taskId}: CLIModeToolbarSlotProps) {
  const {agentMode, isPending, handleModeChange, handleModeChangeError} = useCLIModeSync({sessionId, taskId})

  const {createCommand} = useCreateCommand({
    onError: (_error, snapshot) => {
      const previousMode = (snapshot as {previousMode?: CLIAgentMode})?.previousMode
      if (previousMode) {
        handleModeChangeError(previousMode)
      }
    },
  })

  const onModeChange = useCallback(
    (mode: CLIAgentMode) => {
      const {previousMode} = handleModeChange(mode)
      createCommand({
        sessionId,
        content: JSON.stringify({mode}),
        type: COMMAND_TYPES.MODE_SWITCH,
        snapshot: {previousMode},
      })
    },
    [sessionId, createCommand, handleModeChange],
  )

  return <CLIModePicker selectedMode={agentMode} onModeChange={onModeChange} disabled={isPending} />
}
